import StickyNavPosition from '@models/enums/StickyNavPositionEnum';
import useStickyNavPositionStore from '@state/StickyNavStore';
import { useEffect, useState } from 'react';
import useMediaQuery from './useMediaQuery';

const useStickyOffset = () => {
  const [stickyOffsetHeight, setStickyOffsetHeight] = useState(0);
  const isMobile = useMediaQuery(768);
  const { stickyNavPosition } = useStickyNavPositionStore((state) => ({
    stickyNavPosition: state.stickyNavPosition,
  }));

  useEffect(() => {
    const productNavigation = document.getElementById('ProductNavigation');
    const siteNotifications = document.getElementById('SiteNotifications');

    const isStickyNavOnTop =
      stickyNavPosition === StickyNavPosition.Top ||
      (!isMobile && stickyNavPosition === StickyNavPosition.Bottom);

    const productNavigationHeight =
      productNavigation?.getBoundingClientRect().height ?? 0;

    const siteNotificationsHeight =
      siteNotifications?.getBoundingClientRect().height ?? 0;

    if (isStickyNavOnTop)
      setStickyOffsetHeight(productNavigationHeight + siteNotificationsHeight);
  }, [isMobile, stickyNavPosition]);

  return stickyOffsetHeight;
};

export default useStickyOffset;
